import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { API_SERVICE_BY_CRM, QUERY_KEYS_BY_CRM } from "../../constants";
import { useCrmEnrichmentContext } from "../../contexts/CrmEnrichmentContext";
import type { CrmEnrichmentJobRunHistoryResponse } from "../../types/types";

const useEnrichmentRunHistoryQuery = (
    jobId: string,
    page: number,
    pageSize: number,
): UseQueryResult<CrmEnrichmentJobRunHistoryResponse> => {
    const { crmProvider } = useCrmEnrichmentContext();
    const apiService = API_SERVICE_BY_CRM[crmProvider];
    const queryKeys = QUERY_KEYS_BY_CRM[crmProvider];

    return useQuery({
        enabled: !!jobId,
        queryKey: queryKeys.jobRunHistory(jobId, page, pageSize),
        queryFn({ signal }) {
            return apiService.getJobRunHistory(jobId, { page, pageSize }, { cancellation: signal });
        },
    });
};

export default useEnrichmentRunHistoryQuery;
